import { DownOutlined } from "@ant-design/icons";
import { Button, Popover, Select } from "antd";
import { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SignOut } from "../../components/SignOut";
import { AuthContext } from "../../contexts/authContext";
import { DataAutoRefreshContext } from "../../contexts/dataRefreshContext";

export function UserMenu() {
  const authContext = useContext(AuthContext);
  const { interval, setInterval } = useContext(DataAutoRefreshContext);
  const { i18n, ready, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [version, setVersion] = useState<string>("");

  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setVersion(data.version))
      .catch((err) => {
        console.error("Failed to fetch config.json:", err);
        setVersion("unknown");
      });
  }, []);

  const german = useCallback(() => {
    i18n.changeLanguage("de");
  }, [i18n]);
  const english = useCallback(() => {
    i18n.changeLanguage("en");
  }, [i18n]);

  if (!authContext.currentUser) {
    return <></>;
  }

  const menu = (
    <div style={{ minWidth: 200, padding: 0 }}>
      <div style={{ textAlign: "center", margin: 5 }}>
        App version: {version}
      </div>
      {ready && (
        <div
          className="multi-button-container"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            padding: "5px 12px",
          }}
        >
          <Button
            onClick={german}
            type={
              i18n.language === "de" || i18n.language?.startsWith("de-")
                ? "primary"
                : "default"
            }
          >
            Deutsch
          </Button>
          <Button
            onClick={english}
            type={
              i18n.language === "en" || i18n.language?.startsWith("en-")
                ? "primary"
                : "default"
            }
          >
            English
          </Button>
        </div>
      )}
      <div style={{ borderTop: "1px solid #f0f0f0", margin: "8px 0" }} />
      <div style={{ padding: "5px 12px", width: "100%" }}>
        <div>{t("reload-rate")}</div>
        <Select
          value={interval}
          onChange={setInterval}
          style={{ width: "100%" }}
          getPopupContainer={(trigger) => trigger.parentNode}
        >
          <Select.Option value={1000}>{t("reload-rate-1000")}</Select.Option>
          <Select.Option value={10000}>{t("reload-rate-10000")}</Select.Option>
          <Select.Option value={30000}>{t("reload-rate-30000")}</Select.Option>
          <Select.Option value={60000}>{t("reload-rate-60000")}</Select.Option>
          <Select.Option value={3600000}>
            {t("reload-rate-3600000")}
          </Select.Option>
        </Select>
      </div>
      <div style={{ borderTop: "1px solid #f0f0f0", margin: "8px 0" }} />
      <div style={{ padding: "5px 12px" }}>
        <SignOut />
      </div>
    </div>
  );

  return (
    <Popover
      content={menu}
      trigger="hover"
      open={open}
      onOpenChange={setOpen}
      placement="bottomRight"
      overlayInnerStyle={{ paddingTop: "10px" }}
    >
      <a
        href="/"
        onClick={(e) => {
          e.preventDefault();
        }}
        style={{
          color: "white",
        }}
      >
        {authContext.currentUser.email}{" "}
        <DownOutlined style={{ fontSize: "14px", paddingLeft: "6px" }} />
      </a>
    </Popover>
  );
}
